<svg
  width="1403"
  height="818"
  viewBox="0 0 1403 818"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g filter="url(#filter0_d_650_5542)">
    <path
      d="M152.764 798.716C129.33 798.716 110.269 800.334 110.269 776.183V43.8013C110.269 19.6484 129.33 0 152.764 0H1246.77C1270.2 0 1289.26 19.6484 1289.26 43.8013V776.184C1289.26 800.335 1270.2 798.716 1246.77 798.716L152.764 798.716Z"
      fill="url(#paint0_linear_650_5542)"
    />
    <path
      style="mix-blend-mode:darken"
      d="M152.764 798.716C129.33 798.716 110.269 800.334 110.269 776.183V43.8013C110.269 19.6484 129.33 0 152.764 0H1246.77C1270.2 0 1289.26 19.6484 1289.26 43.8013V776.184C1289.26 800.335 1270.2 798.716 1246.77 798.716L152.764 798.716Z"
      fill="url(#paint1_linear_650_5542)"
    />
    <path
      d="M1287.13 41.3776C1287.13 19.3663 1269.82 1.52002 1248.47 1.52002H153.469C139.132 1.52002 126.628 9.5704 119.95 21.5181C127.018 12.0209 138.133 5.89262 150.643 5.89262H1245.64C1267 5.89262 1284.31 23.7389 1284.31 45.7485V778.817C1284.31 786.055 1283.9 783.427 1280.63 789.279C1285.62 782.558 1287.13 783.564 1287.13 774.449V41.3776Z"
      fill="url(#paint2_linear_650_5542)"
    />
    <path
      d="M1248.47 793.035H153.468C132.115 793.035 114.804 796.462 114.804 774.448V41.3778C114.804 34.1444 116.681 27.3637 119.949 21.5183C114.949 28.2356 111.976 36.6312 111.976 45.7487V778.817C111.976 800.831 129.284 797.399 150.642 797.399H1245.64C1259.98 797.399 1276.67 794.043 1283.35 782.1C1276.28 791.593 1260.97 793.035 1248.47 793.035L1248.47 793.035Z"
      fill="url(#paint3_linear_650_5542)"
    />
    <path
      d="M149.017 789.6C131.857 789.6 117.895 796.482 117.895 778.788V41.1961C117.895 23.5083 131.857 9.1106 149.017 9.1106H1250.51C1267.68 9.1106 1281.64 23.5088 1281.64 41.1961V778.788C1281.64 796.482 1267.82 792.451 1250.65 792.451L149.017 789.6Z"
      fill="black"
    />
    <path d="M1260.1 34.7026H140V701.866H1260.1V34.7026Z" fill="black" />
    <path
      d="M1281.64 753.598H117.893V756.329H1281.64V753.598Z"
      fill="#404041"
    />
    <path
      d="M704.687 21.6782C704.687 18.9459 702.538 16.7307 699.888 16.7307C697.237 16.7307 695.088 18.9459 695.088 21.6782C695.088 24.4105 697.237 26.6257 699.888 26.6257C702.538 26.6257 704.687 24.4105 704.687 21.6782Z"
      fill="#58595B"
    />
    <path
      d="M699.644 26.3039C702.295 26.3039 704.444 24.0888 704.444 21.3564C704.444 18.624 702.295 16.4089 699.644 16.4089C696.994 16.4089 694.845 18.624 694.845 21.3564C694.845 24.0888 696.994 26.3039 699.644 26.3039Z"
      fill="#8F8F8F"
    />
    <path
      d="M702.549 24.3519C704.154 22.6976 704.154 20.0153 702.549 18.361C700.944 16.7066 698.342 16.7066 696.737 18.361C695.132 20.0154 695.132 22.6976 696.737 24.3519C698.342 26.0063 700.944 26.0063 702.549 24.3519Z"
      fill="#231F20"
    />
    <path
      d="M699.644 24.2369C701.187 24.2369 702.439 22.9473 702.439 21.3564C702.439 19.7655 701.187 18.4758 699.644 18.4758C698.101 18.4758 696.85 19.7655 696.85 21.3564C696.85 22.9473 698.101 24.2369 699.644 24.2369Z"
      fill="#454545"
    />
    <path
      d="M699.644 22.1583C700.074 22.1583 700.423 21.7995 700.423 21.3569C700.423 20.9142 700.074 20.5554 699.644 20.5554C699.214 20.5554 698.865 20.9142 698.865 21.3569C698.865 21.7995 699.214 22.1583 699.644 22.1583Z"
      fill="black"
    />
    <path
      d="M1399.53 779.469H699.766H0V796.64H1399.53V779.469Z"
      fill="url(#paint4_linear_650_5542)"
    />
    <path
      d="M0 796.64V796.652C0 796.652 43.9905 815.287 75.9264 814.667L699.766 814.684L1323.6 814.667C1355.54 815.287 1399.53 796.652 1399.53 796.652V796.64H0Z"
      fill="url(#paint5_linear_650_5542)"
    />
    <path d="M1399.53 779.469H1395.8V796.64H1399.53V779.469Z" fill="#E6E7E8" />
    <path
      d="M3.82107 779.469H0.0966797V796.64H3.82107V779.469Z"
      fill="#E6E7E8"
    />
    <path
      d="M1287.99 788.458C1287.99 787.073 1286.9 785.95 1285.56 785.95C1284.21 785.95 1283.12 787.073 1283.12 788.458C1283.12 789.843 1284.21 790.966 1285.56 790.966C1286.9 790.966 1287.99 789.844 1287.99 788.458Z"
      fill="#58595B"
    />
    <path
      d="M1285.43 790.803C1286.78 790.803 1287.87 789.68 1287.87 788.295C1287.87 786.91 1286.78 785.787 1285.43 785.787C1284.09 785.787 1283 786.91 1283 788.295C1283 789.68 1284.09 790.803 1285.43 790.803Z"
      fill="#BCBEC0"
    />
    <path
      d="M1287.52 788.295C1287.52 787.109 1286.58 786.148 1285.43 786.148C1284.28 786.148 1283.35 787.109 1283.35 788.295C1283.35 789.481 1284.28 790.442 1285.43 790.442C1286.58 790.442 1287.52 789.481 1287.52 788.295Z"
      fill="#333333"
    />
    <path
      d="M1304.93 788.538C1304.93 785.805 1302.78 783.59 1300.13 783.59C1297.48 783.59 1295.33 785.805 1295.33 788.538C1295.33 791.27 1297.48 793.485 1300.13 793.485C1302.78 793.485 1304.93 791.27 1304.93 788.538Z"
      fill="#58595B"
    />
    <path
      d="M1299.88 793.163C1302.53 793.163 1304.68 790.947 1304.68 788.215C1304.68 785.483 1302.53 783.268 1299.88 783.268C1297.23 783.268 1295.08 785.483 1295.08 788.215C1295.08 790.947 1297.23 793.163 1299.88 793.163Z"
      fill="#BCBEC0"
    />
    <path
      d="M1302.79 791.21C1304.39 789.556 1304.39 786.874 1302.79 785.219C1301.18 783.565 1298.58 783.565 1296.97 785.219C1295.37 786.874 1295.37 789.556 1296.97 791.21C1298.58 792.864 1301.18 792.865 1302.79 791.21Z"
      fill="#4D4D4D"
    />
    <path
      d="M1319.43 788.538C1319.43 785.805 1317.28 783.59 1314.63 783.59C1311.98 783.59 1309.83 785.805 1309.83 788.538C1309.83 791.27 1311.98 793.485 1314.63 793.485C1317.28 793.485 1319.43 791.27 1319.43 788.538Z"
      fill="#58595B"
    />
    <path
      d="M1314.39 793.163C1317.04 793.163 1319.19 790.948 1319.19 788.216C1319.19 785.483 1317.04 783.268 1314.39 783.268C1311.74 783.268 1309.59 785.483 1309.59 788.216C1309.59 790.948 1311.74 793.163 1314.39 793.163Z"
      fill="#BCBEC0"
    />
    <path
      d="M1317.29 791.211C1318.9 789.556 1318.9 786.874 1317.29 785.22C1315.69 783.565 1313.09 783.565 1311.48 785.22C1309.88 786.874 1309.88 789.556 1311.48 791.211C1313.09 792.865 1315.69 792.865 1317.29 791.211Z"
      fill="#4D4D4D"
    />
    <path
      d="M699.858 779.469H608.497C608.497 779.469 610.514 789.278 630.107 789.278H769.424C789.017 789.278 791.034 779.469 791.034 779.469H699.858Z"
      fill="url(#paint6_linear_650_5542)"
    />
    <path
      d="M787.65 779.469C786.657 782.753 781.215 788.078 766.3 788.078H627.782C622.434 788.078 618.409 787.475 615.375 786.533C618.58 788.078 623.457 789.278 630.871 789.278H769.389C788.869 789.278 791.032 779.469 791.032 779.469H787.65Z"
      fill="#D1D3D4"
    />
  </g>
  <defs>
    <filter
      id="filter0_d_650_5542"
      x="0"
      y="0"
      width="1402.53"
      height="817.684"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="3" dy="3" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_650_5542"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_650_5542"
        result="shape"
      />
    </filter>
    <linearGradient
      id="paint0_linear_650_5542"
      x1="110.269"
      y1="399.369"
      x2="1289.26"
      y2="399.369"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#E6E6E6" />
      <stop offset="0.364" stop-color="#4D4D4D" />
      <stop offset="0.564" stop-color="#CCCCCC" />
      <stop offset="0.764" stop-color="#575757" />
      <stop offset="1" stop-color="#919191" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_650_5542"
      x1="699.766"
      y1="0"
      x2="699.766"
      y2="798.738"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#E6E6E6" />
      <stop offset="1" stop-color="#919191" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_650_5542"
      x1="1242.74"
      y1="818.93"
      x2="477.572"
      y2="-241.212"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#919191" />
      <stop offset="0.167" stop-color="#979797" />
      <stop offset="0.399" stop-color="#A9A9A9" />
      <stop offset="0.669" stop-color="#C7C7C7" />
      <stop offset="0.966" stop-color="#EFEFEF" />
      <stop offset="1" stop-color="#F5F5F5" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_650_5542"
      x1="890.52"
      y1="1068.23"
      x2="128.778"
      y2="12.8379"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#E6E6E6" />
      <stop offset="0.364" stop-color="#4D4D4D" />
      <stop offset="0.564" stop-color="#CCCCCC" />
      <stop offset="1" stop-color="#919191" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_650_5542"
      x1="0"
      y1="788.054"
      x2="1399.53"
      y2="788.054"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.006" stop-color="white" />
      <stop offset="0.03" stop-color="#737373" />
      <stop offset="0.034" stop-color="#7F7F7F" />
      <stop offset="0.046" stop-color="#9C9D9E" />
      <stop offset="0.058" stop-color="#B3B5B5" />
      <stop offset="0.071" stop-color="#C4C5C6" />
      <stop offset="0.085" stop-color="#CDCFD0" />
      <stop offset="0.103" stop-color="#D1D3D4" />
      <stop offset="0.352" stop-color="#D6D8D9" />
      <stop offset="0.503" stop-color="#F3F4F4" />
      <stop offset="0.655" stop-color="#E6E7E8" />
      <stop offset="0.9" stop-color="#D1D3D4" />
      <stop offset="0.964" stop-color="#737373" />
      <stop offset="1" stop-color="white" />
    </linearGradient>
    <linearGradient
      id="paint5_linear_650_5542"
      x1="699.765"
      y1="814.684"
      x2="699.765"
      y2="796.64"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.248" stop-color="#616161" />
      <stop offset="0.405" stop-color="#686868" />
      <stop offset="0.638" stop-color="#7C7C7C" />
      <stop offset="0.8" stop-color="#8F8F8F" />
      <stop offset="1" stop-color="#949494" />
    </linearGradient>
    <linearGradient
      id="paint6_linear_650_5542"
      x1="699.766"
      y1="779.469"
      x2="699.766"
      y2="789.278"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#999999" />
      <stop offset="1" stop-color="#4D4D4D" />
    </linearGradient>
  </defs>
</svg>
